export const commonColors: Record<string, string | undefined> = {
    primary: import.meta.env.VITE_APP_PRIMARY_COLOR
}
